/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useCallback, useEffect, useState } from 'react';
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';

// Components
import {
  LoadingScreen,
  notifyError,
  PageWrapper,
} from '../containers/componentsInjection';

// Helpers
import { APIClient } from '../../../helpers/api_helper';

export const Whatsapp = () => {
  const [image, setImage] = useState('');
  const [loading, setLoading] = useState(true);
  const [isConnected, setIsConnected] = useState(false);

  const api = new APIClient();

  const requestGetWhatsappStatus = useCallback(async () => {
    api
      .get(`whatsapp/status`)
      .then((res) => {
        setImage(res.qrCode || null);
        setIsConnected(res.isConnected);
      })
      .catch((err) => {
        notifyError(err?.message || 'Erro ao verificar o status da instância');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    requestGetWhatsappStatus();
  }, []);

  return (
    <LoadingScreen loading={loading} titleMetaTag={'Whatsapp'}>
      <PageWrapper title={'Whatsapp'}>
        {isConnected ? (
          <Alert color="success" className="alert-border-left">
            <i className="ri-check-double-line me-3 align-middle fs-16"></i>
            Sua instância do <strong>WhatsApp está conectada!</strong> Você já
            pode enviar e receber mensagens pela plataforma.
          </Alert>
        ) : (
          <Alert color="danger" className="alert-border-left mb-3">
            <i className="ri-error-warning-line me-3 align-middle fs-16"></i>
            Sua instância está <strong>desconectada!</strong> Abra o WhatsApp e
            leia o QR Code abaixo para se conectar a esta instância.
          </Alert>
        )}

        {!isConnected && image && (
          <Card>
            <CardBody>
              <Row className="g-3">
                <Col>
                  <img
                    src={image}
                    alt="QR Code para conectar WhatsApp"
                    style={{ width: 300, height: 300 }}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </PageWrapper>
    </LoadingScreen>
  );
};
